import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { useDataModel } from '@thd-nucleus/data-sources';
import { shipping } from '../helpers/model';
import { getDETAZip, getDeliveryZip } from '../helpers/utils';
import DeliveryContent from './DeliveryContent';
import './delivery-options.style.scss';
import { track } from '../analytics';
import { dataModel } from './dataModel';

const DeliveryOptions = (props) => {
  let {
    storeId,
    zipCode
  } = props;
  const {
    itemId,
    quantity,
    children,
    visible
  } = props;

  const storeDetails = useStore();
  const { storeZip } = storeDetails;
  if (!storeId) {
    storeId = storeDetails.storeId;
  }
  const productQueryProps = {
    variables: { itemId, storeId },
    ssr: false
  };
  const { data } = useDataModel('clientOnlyProduct', productQueryProps);
  const { value } = data?.product?.pricing || {};
  const detaZip = getDETAZip();
  const deliveryZip = getDeliveryZip();
  zipCode = zipCode || deliveryZip || detaZip || storeZip;

  const shippingQueryProps = {
    variables: {
      itemId,
      storeId,
      zipCode,
      quantity,
      price: parseInt((value * quantity).toFixed(2), 10)
    }
  };
  const [getShipping, shippingResponse] = useDataModel('shipping', shippingQueryProps, true);
  useEffect(() => {
    if (value && storeId !== '8119') {
      getShipping();
    }
  }, [value, quantity, storeId, zipCode]);

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    track('click', {
      origin: 'delivery-options',
      eventName: 'shipping options',
      primaryCategory: 'tooltip'
    });
  };

  if ((shippingResponse.error && !shippingResponse.data) || !shippingResponse.data || shippingResponse.loading) {
    return null;
  }

  const shippingModel = shipping(shippingResponse.data.shipping);

  return (
    <div className="delivery-options">
      <Tooltip
        channel="desktop"
        closeButton
        visible={visible}
        content={(
          <DeliveryContent
            zipCode={zipCode}
            shippingModel={shippingModel}
          />
        )}
        maxWidth={320}
        placement="bottom"
      >
        <button type="button" className="u__default-link" onClick={handleOnClick}>
          {children}
        </button>
      </Tooltip>
    </div>
  );
};

DeliveryOptions.displayName = 'DeliveryOptions';

DeliveryOptions.propTypes = {
  itemId: PropTypes.string.isRequired,
  storeId: PropTypes.string,
  zipCode: PropTypes.string,
  children: PropTypes.node,
  visible: PropTypes.bool,
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

DeliveryOptions.defaultProps = {
  children: 'Delivery Options',
  storeId: '',
  zipCode: '',
  quantity: 1,
  visible: false
};

DeliveryOptions.dataModel = dataModel;

export default DeliveryOptions;
